import React, { createContext, useState } from 'react';

export type FilterType = 'AllTrain' | 'LowFloor';

type FilterContextType = {
  filter: FilterType;
  setFilter: React.Dispatch<React.SetStateAction<FilterType>>;
};

export const FliterContext = createContext({} as FilterContextType);

type Props = {
  children: React.ReactNode;
};

// 表示車両のフィルタ状態を記憶するContext
export const FliterContextProvider: React.FC<Props> = (props) => {
  const [filter, setFilter] = useState<FilterType>('AllTrain');

  return (
    <FliterContext.Provider value={{ filter, setFilter }}>
      {props.children}
    </FliterContext.Provider>
  );
};
